import React from 'react';
import withIcon from '../utilities/withIcon';

const IconLogoFacebook = () => {
  return (
    <g>
      <path d="M8.927 4.548V3.43c0-.642.597-.872 1.263-.872.467.012.93.079 1.381.199L12 .307A11.18 11.18 0 0 0 8.927.01a3.093 3.093 0 0 0-2.66 1.204 4.169 4.169 0 0 0-.552 2.477v1.607H4V7.69h1.714V16h3.213V7.69h2.543l.19-2.392H8.927v-.75z" />
    </g>
  );
};

export default withIcon(IconLogoFacebook);
